/**
 * Opción por defecto de propuestas.
 * @const
 * @default "opc1"
 */
export const PROPOSALS_OPTION_DEFAULT = {
    DEFAULT_OPTIONS: 'opc1'
};
